import { useRolodexFileLS, useRolodexSignedURLs } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexSignedURLResult } from 'types'

export interface AssetDrawings {
  heatmap?: {
    imagePath: string
    signedUrl?: string
  }[]
  noHeatmap?: {
    imagePath: string
    signedUrl?: string
  }[]
  withIndicationsHeatmap?: {
    imagePath: string
    signedUrl?: string
  }[]
  withWeldsNoHeatmap?: {
    imagePath: string
    signedUrl?: string
  }[]
}

function addDrawing(result: RolodexSignedURLResult, drawings: AssetDrawings) {
  if (result.path?.includes('full-asset-heatmap')) {
    drawings.heatmap?.push({
      imagePath: result.path,
      signedUrl: result.signed_url,
    })
  } else if (result.path?.includes('full-asset-no-heatmap')) {
    drawings.noHeatmap?.push({
      imagePath: result.path,
      signedUrl: result.signed_url,
    })
  } else if (result.path?.includes('full-asset-with-indications-heatmap')) {
    drawings.withIndicationsHeatmap?.push({
      imagePath: result.path,
      signedUrl: result.signed_url,
    })
  } else if (result.path?.includes('full-asset-weld-scan-plan')) {
    drawings.withWeldsNoHeatmap?.push({
      imagePath: result.path,
      signedUrl: result.signed_url,
    })
  }
}

export const useAssetDrawings = (
  metadataEntryId: string,
  inspIds: string[]
) => {
  const { fileRefs: assetDrawingRefs } = useRolodexFileLS({
    entry_id: metadataEntryId,
    path: 'asset-drawing/**',
  })

  const { results: assetDrawingUrls } = useRolodexSignedURLs(
    assetDrawingRefs.map((ref) => ({
      entry_id: metadataEntryId,
      path: ref.path,
    }))
  )

  const assetDrawings = useMemo(() => {
    const drawingsByInspection: Map<string, AssetDrawings> = new Map()

    inspIds.forEach((insp) => {
      const urls = assetDrawingUrls.filter((result) =>
        result.path.includes(insp)
      )
      const drawings: AssetDrawings = {
        withIndicationsHeatmap: [],
        heatmap: [],
        noHeatmap: [],
        withWeldsNoHeatmap: [],
      }
      urls.forEach((url) => addDrawing(url, drawings))
      drawingsByInspection.set(insp, drawings)
    })
    return drawingsByInspection as ReadonlyMap<string, AssetDrawings>
  }, [assetDrawingUrls, inspIds])

  return assetDrawings
}
